// extracted by mini-css-extract-plugin
export var buttonsContainer = "RemoveAddressModal_buttonsContainer__6RVQy";
export var container = "RemoveAddressModal_container__8kY91";